module.exports = __webpack_public_path__ + "static/media/signin.dd3dca29.svg";